import React from "react"
import { WingsBadge } from "../badges"
import { WingsDetailText as WingsDetailText } from "../typography"

/**
 * Detail in a card. Not currently exported from wingspans-ui 
 * @prop {string} label
 * @prop {string} value 
 * @returns {JSX}
 */
const WingsCardDetail = ({label, value}) => {
  return (
    <div className="w-flex w-flex-row w-gap-1 w-justify-start w-items-center">
      <WingsBadge size="narrow">{label}</WingsBadge>
      <WingsDetailText className="w-font-bold">{value}</WingsDetailText>
    </div>
  )
}

export default WingsCardDetail
